import React from "react";
import { Search, Droplet, CheckCheck } from "lucide-react";
import { isGroupJid } from "../../../lib/sortChats";
import { ChatAvatar } from "./ChatAvatar";
import { formatJidAsPhone } from "./formatPhone";
// eslint-disable-next-line no-restricted-imports
import { useToast } from "../../../../../shared/ui/Toast/ToastProvider";
// 02.7-settings.md §5/paso b -- extraído de WhatsPanel.jsx (búsqueda + tabs de filtro + lista de
// chats). Puramente presentacional: recibe la lista ya filtrada/ordenada por props, `onSelectChat`
// es el único callback (la escritura optimista en la cache compartida vive en el container).
export default function WhatsChatList({
  chats, loading, searchTerm, onSearchChange, activeFilter, onFilterChange, onSelectChat, scrollRef,
}) {
  const toast = useToast();
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <div
        className="todo-search-container"
        style={{ padding: "0 var(--space-4)", marginBottom: "10px" }}
      >
        <div className="whats-search-wrapper" style={{ marginBottom: "10px" }}>
          <Search className="whats-search-icon" size={16} />
          <input
            type="text"
            className="todo-search-input"
            placeholder="Buscar conversación..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        <div style={{ display: "flex", gap: "var(--space-2)", overflowX: "auto", paddingBottom: "var(--space-1)" }} className="whats-filters-row">
          {["Flow", "Todos", "No leídos", "Importantes"].map(filter => (
            <button
              key={filter}
              onClick={() => onFilterChange(filter)}
              style={{
                background: activeFilter === filter ? (filter === "Flow" ? "#e0f2fe" : "#e2e8f0") : "transparent",
                border: activeFilter === filter ? "none" : (filter === "Flow" ? "1px solid #7dd3fc" : "1px solid #ddd"),
                borderRadius: "var(--radius-xl)",
                padding: "var(--space-1) var(--space-3)",
                fontSize: "12px",
                fontWeight: "500",
                color: activeFilter === filter ? (filter === "Flow" ? "#0284c7" : "#111") : "#555",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "var(--space-1)"
              }}
            >
              {filter === "Flow" && <Droplet size={14} color={activeFilter === "Flow" ? "#0284c7" : "#7dd3fc"} />}
              {filter}
            </button>
          ))}
        </div>
      </div>

      <div
        className="todo-panel-content"
        style={{ flex: 1, overflowY: "auto", padding: "0 10px" }}
        ref={scrollRef}
      >
        {loading ? (
          <div
            style={{
              textAlign: "center",
              padding: "var(--space-5)",
              color: "#888",
            }}
          >
            Cargando chats...
          </div>
        ) : (
          <div className="whats-chat-list">
            {chats.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  color: "#888",
                  marginTop: "var(--space-5)",
                }}
              >
                No hay chats activos.
              </div>
            ) : (
              (() => {
                let lastDate = null;
                return chats.map((chat) => {
                  let showDate = false;
                  let dateLabel = "";
                  if (chat.last_message_timestamp) {
                    const chatDate = new Date(chat.last_message_timestamp);
                    const dateStr = chatDate.toLocaleDateString();
                    if (dateStr !== lastDate) {
                      showDate = true;
                      lastDate = dateStr;
                      const today = new Date();
                      const yesterday = new Date();
                      yesterday.setDate(yesterday.getDate() - 1);
                      if (dateStr === today.toLocaleDateString()) {
                        dateLabel = "HOY";
                      } else if (dateStr === yesterday.toLocaleDateString()) {
                        dateLabel = "AYER";
                      } else {
                        dateLabel = chatDate.toLocaleDateString("es-ES", { day: "numeric", month: "short" }).toUpperCase();
                      }
                    }
                  }

                  const chatPriority = chat.priority || 'baja';
                  const isUrgente = chatPriority === 'urgente';
                  const isAlta = chatPriority === 'alta';

                  return (
                    <React.Fragment key={chat.chat_jid}>
                      {showDate && (
                        <div style={{ display: "flex", justifyContent: "center", margin: "var(--space-3) 0", position: "sticky", top: "0", zIndex: 10 }}>
                          <span style={{ backgroundColor: "rgba(255, 255, 255, 0.95)", padding: "6px 14px", borderRadius: "var(--radius-lg)", fontSize: "12px", color: "#54656f", boxShadow: "0 1px 2px rgba(11,20,26,0.08)", fontWeight: "500" }}>
                            {dateLabel}
                          </span>
                        </div>
                      )}
                      <div
                        className={`whats-chat-item ${isUrgente ? 'urgente' : ''}`}
                        style={{
                          borderLeft: isUrgente ? '4px solid #ef4444' : (isAlta ? '4px solid #eab308' : '4px solid transparent'),
                          backgroundColor: 'transparent'
                        }}
                        onClick={() => onSelectChat(chat)}
                      >
                        <div
                          style={{
                            marginRight: "var(--space-2)",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <CheckCheck
                            size={16}
                            color={
                              chat.unread_count > 0 ? "#f97316" : "#9ca3af"
                            }
                          />
                        </div>
                        <div className="whats-chat-avatar" style={{ borderRadius: isGroupJid(chat.chat_jid) ? "8px" : "50%" }}>
                          <ChatAvatar
                            url={chat.avatar_url}
                            name={chat.name}
                            jid={chat.chat_jid}
                            isGroup={isGroupJid(chat.chat_jid)}
                          />
                        </div>
                        <div className="whats-chat-info" style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", paddingRight: "5px" }}>
                          <div className="whats-chat-name" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {chat.name || formatJidAsPhone(chat.chat_jid)}
                            </span>
                            {chat.chat_jid && (
                              <span
                                style={{
                                  fontSize: "10px",
                                  color: "#6b7280",
                                  backgroundColor: "#f3f4f6",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  marginLeft: "8px",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap"
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(chat.chat_jid);
                                  toast.success(`ID copiado: ${chat.chat_jid}`);
                                }}
                                title="Copiar ID"
                              >
                                #{String(chat.chat_jid).split("@")[0].slice(-4)}
                              </span>
                            )}
                          </div>
                          <div className="whats-chat-preview" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "2px" }}>
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, color: chat.unread_count > 0 ? "#111" : "#667781", fontWeight: chat.unread_count > 0 ? "500" : "normal" }}>
                              {chat.last_message_text || "Mensaje de sistema"}
                            </span>
                            {(chat.unread_count > 0 || chat.unread_mentions_count > 0) && (
                              <div style={{ display: "flex", alignItems: "center", gap: "var(--space-1)", marginLeft: "var(--space-2)" }}>
                                {/* Integración main→dev, epic E (`0241cc9e`): badge de mención (`@`),
                                    ahora sobre el campo real `unread_mentions_count` (migración 157). */}
                                {chat.unread_mentions_count > 0 && (
                                  <span style={{ color: "#25D366", fontSize: "14px", fontWeight: "bold" }} title="Te mencionaron">@</span>
                                )}
                                {chat.unread_count > 0 && (
                                  <span style={{ backgroundColor: "#25D366", color: "#fff", borderRadius: "10px", padding: "2px 6px", fontSize: "11px", fontWeight: "bold", minWidth: "18px", textAlign: "center" }}>
                                    {chat.unread_count}
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                });
              })()
            )}
          </div>
        )}
      </div>
    </div>
  );
}
